class LocationMap {
  constructor( locationmapcontainer ) {
    this.locationmapcontainer = locationmapcontainer;
    this.map = null;
    this.timeout = null;
    this.markerids = [];
    this.markerscluster = null;
    this.dynamicmarkers = [];
    this.contentobjectid = ( this.locationmapcontainer.dataset.contentobjectid? parseInt( this.locationmapcontainer.dataset.contentobjectid ) : 0 );
    this.showmarker = ( this.locationmapcontainer.dataset.showmarker? parseInt( this.locationmapcontainer.dataset.showmarker ) : true );
    this.showothermarkers = ( this.locationmapcontainer.dataset.showothermarkers? parseInt( this.locationmapcontainer.dataset.showothermarkers ) : true );
    this.classidentifiers = ( this.locationmapcontainer.dataset.classidentifiers? JSON.parse( this.locationmapcontainer.dataset.classidentifiers ) : [] );
    this.parentpathstrings = ( this.locationmapcontainer.dataset.parentpathstrings? JSON.parse( this.locationmapcontainer.dataset.parentpathstrings ) : [] );
    this.authorizepremium = ( this.locationmapcontainer.dataset.authorizepremium? parseInt( this.locationmapcontainer.dataset.authorizepremium ) : false );
    this.onlypremium = ( this.locationmapcontainer.dataset.onlypremium? parseInt( this.locationmapcontainer.dataset.onlypremium ) : false );
    this.classids = ( this.locationmapcontainer.dataset.classids? JSON.parse( this.locationmapcontainer.dataset.classids ) : [] );
    this.tagids = ( this.locationmapcontainer.dataset.tagids? JSON.parse( this.locationmapcontainer.dataset.tagids ) : [] );
    //manual selection
    this.points = ( this.locationmapcontainer.dataset.points? JSON.parse( this.locationmapcontainer.dataset.points ) : [] );
    this.ispath = ( this.locationmapcontainer.dataset.ispath? parseInt( this.locationmapcontainer.dataset.ispath ) : false );
  }
  async loadleafletstyle(){
    return new Promise((resolve, reject) => {
      if( !document.body.dataset.leafletstyleloaded ){
        leafletstyle.addEventListener('load', (event) => {
          leafletstyle.dataset.loaded = true;
          resolve();
        });
        leafletstyle.addEventListener('error', (event) => {
          leafletstyle.dataset.onerror = true;
          reject();
        });
        leafletstyle.href = '/vendor/bayard-admin/locationselector/css/leaflet.css';
        leafletstyle.rel = 'stylesheet';
        leafletstyle.type = 'text/css';
        document.head.appendChild(leafletstyle);
        document.body.dataset.leafletstyleloaded = "1";
      } else {
        if( leafletstyle.dataset.loaded ){
          resolve();
        } else if( leafletstyle.dataset.onerror ){
          reject();
        } else {
          leafletstyle.addEventListener('load', (event) => {
            resolve();
          });
          leafletstyle.addEventListener('error', (event) => {
            reject();
          });
        }
      }
    });
  }

  async loadleafletscript(){
    return new Promise((resolve, reject) => {
      if( !document.body.dataset.leafletsriptloaded ){
        leafletscript.src = '/vendor/bayard-admin/locationselector/js/leaflet.js';
        leafletscript.addEventListener('load', (event) => {
          leafletscript.dataset.loaded = true;
          resolve();
        });
        leafletscript.addEventListener('error', (event) => {
          leafletscript.dataset.onerror = true;
          reject();
        });
        document.head.appendChild(leafletscript);
        document.body.dataset.leafletsriptloaded = "1";
      } else {
        if( leafletscript.dataset.loaded ){
          resolve();
        } else if( leafletscript.dataset.onerror ){
          reject();
        } else {
          leafletscript.addEventListener('load', (event) => {
            resolve();
          });
          leafletscript.addEventListener('error', (event) => {
            reject();
          });
        }
      }
    });
  }

  async loadleafletclusterscript(){
    return new Promise((resolve, reject) => {
      if( !document.body.dataset.leafletclusterscriptloaded ){
        leafletclusterscript.src = '/vendor/bayard-admin/locationselector/js/leaflet-markercluster.js';
        leafletclusterscript.addEventListener('load', (event) => {
          leafletclusterscript.dataset.loaded = true;
          resolve();
        });
        leafletclusterscript.addEventListener('error', (event) => {
          leafletclusterscript.dataset.onerror = true;
          reject();
        });
        document.head.appendChild(leafletclusterscript);
        document.body.dataset.leafletclusterscriptloaded = "1";
      } else {
        if( leafletclusterscript.dataset.loaded ){
          resolve();
        } else if( leafletclusterscript.dataset.onerror ){
          reject();
        } else {
          leafletclusterscript.addEventListener('load', (event) => {
            resolve();
          });
          leafletclusterscript.addEventListener('error', (event) => {
            reject();
          });
        }
      }
    });
  }

  async loadleafletclusterstyle(){
    return new Promise((resolve, reject) => {
      if( !document.body.dataset.leafletclusterstyleloaded ){
        leafletclusterstyle.addEventListener('load', (event) => {
          leafletclusterstyle.dataset.loaded = true;
          resolve();
        });
        leafletclusterstyle.addEventListener('error', (event) => {
          leafletclusterstyle.dataset.onerror = true;
          reject();
        });
        leafletclusterstyle.href = '/vendor/bayard-admin/locationselector/css/leaflet-markercluster.css';
        leafletclusterstyle.rel = 'stylesheet';
        leafletclusterstyle.type = 'text/css';
        document.head.appendChild(leafletclusterstyle);
        document.body.dataset.leafletclusterstyleloaded = "1";
      } else {
        if( leafletclusterstyle.dataset.loaded ){
          resolve();
        } else if( leafletclusterstyle.dataset.onerror ){
          reject();
        } else {
          leafletclusterstyle.addEventListener('load', (event) => {
            resolve();
          });
          leafletclusterstyle.addEventListener('error', (event) => {
            reject();
          });
        }
      }
    });
  }

  async loadmainmarker(){
    let lat  = this.locationmapcontainer.dataset.latitude? parseFloat( this.locationmapcontainer.dataset.latitude ) : null;
    let lon  = this.locationmapcontainer.dataset.longitude? parseFloat( this.locationmapcontainer.dataset.longitude ) : null;
    let zoom  = this.locationmapcontainer.dataset.zoom? parseInt( this.locationmapcontainer.dataset.zoom ) : null;
    let contentobjectid  = this.locationmapcontainer.dataset.contentobjectid? parseInt( this.locationmapcontainer.dataset.contentobjectid ) : null;
    let showmarker  = this.locationmapcontainer.dataset.showmarker? parseInt( this.locationmapcontainer.dataset.showmarker ) : null;
    let LatLong = [ lat , lon ];
    this.map = L.map( this.locationmapcontainer.id ).setView(LatLong, zoom);
    L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
    } ).addTo(this.map);
    if( showmarker ){
      L.Icon.Default.imagePath = '/vendor/bayard-admin/locationselector/images/markers/';
      L.marker( LatLong ).addTo(this.map);
      if( contentobjectid ){
        this.markerids.push( contentobjectid );
      }
    }
  }

  async updatedynamicmarkers( locationmap, Bounds, MarkerCluster ){
    let minLat = Bounds.getNorthWest().lat;
    let maxLat = Bounds.getSouthEast().lat;
    let minLong = Bounds.getNorthWest().lng;
    let maxLong = Bounds.getSouthEast().lng;

    return new Promise((resolve, reject) => {
      return fetch( '/locationmap/ajaxpoints', {
        cache: "no-store",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          minLat: minLat,
          maxLat: maxLat,
          minLong: minLong,
          maxLong: maxLong,
          class_identifier: this.classidentifiers,
          parent_pathstrings: this.parentpathstrings,
          authorizepremium: this.authorizepremium,
          onlypremium: this.onlypremium,
          classids: this.classids,
          tagids: this.tagids,
        }),
      } ).then( (response) => {
        return response.json();
      }).then( (datas) => {
        if( datas.success ){
          if( MarkerCluster ){
            locationmap.removeLayer( MarkerCluster );
          }
          MarkerCluster = L.markerClusterGroup();
          let i = 0;
          for(i = 0; i < datas.results.length; i++){
            if( this.contentobjectid != datas.results[i].id && !this.markerids.includes( datas.results[i].id ) && datas.results[i].location && datas.results[i].location.latlon && parseFloat( datas.results[i].location.latlon.lat ) && parseFloat( datas.results[i].location.latlon.lon ) ){
              L.Icon.Default.imagePath = '/vendor/bayard-admin/locationselector/images/markers/';
              let popupoptions = { 'minWidth': 300, 'maxWidth': 500 };
              let marker = L.marker( L.latLng(datas.results[i].location.latlon.lat, datas.results[i].location.latlon.lon) ).bindPopup( datas.results[i].html, popupoptions );
              MarkerCluster.addLayer( marker );
              this.markerids.push( datas.results[i].id );
            }
          }
          locationmap.addLayer( MarkerCluster );
          resolve();
        } else {
          reject( 'Erreur lors de la recuperation des points' );
        }
      }).catch( (error) => {
        reject( 'Erreur lors de l\'envoi de demande des points' );
      });
    });
  }

  async initdynamicmarkers(){
    let LocationMap = this;
    if( this.showothermarkers ){
      if( this.points.length ){
        // manual markers
        let waypointbypath = [];
        for(let i = 0; i < this.points.length; i++){
          if( !this.markerids.includes( this.points[i].id ) && this.points[i].location && this.points[i].location.latlon && parseFloat( this.points[i].location.latlon.lat ) && parseFloat( this.points[i].location.latlon.lon ) ){
            L.Icon.Default.imagePath = '/vendor/bayard-admin/locationselector/images/markers/';
            let popupoptions = { 'minWidth': 300, 'maxWidth': 500 };
            L.marker( L.latLng(this.points[i].location.latlon.lat, this.points[i].location.latlon.lon) ).addTo(LocationMap.map).bindPopup( this.points[i].html, popupoptions );
            LocationMap.markerids.push( this.points[i].id );
            if( LocationMap.ispath ){
              waypointbypath.push( L.latLng(this.points[i].location.latlon.lat, this.points[i].location.latlon.lon) );
            }
          }
        }
        if( waypointbypath.length ){
          let polyline = new L.polyline( waypointbypath, { id: 'path-'+ ( Math.floor(Math.random() * Date.now()) ) } );
          polyline.setStyle({
            color: "#6bc301",
            weight:7,
          });
          polyline.addTo(LocationMap.map);
        }
      } else { 
        LocationMap.map.on( 'load', function(){
          clearTimeout(LocationMap.timeout);
          LocationMap.timeout = setTimeout( function(){ LocationMap.updatedynamicmarkers( LocationMap.map, LocationMap.map.getBounds(), LocationMap.markerscluster ); }, 1000 );
        });
        LocationMap.map.on( 'moveend', function(){
          clearTimeout(LocationMap.timeout);
          LocationMap.timeout = setTimeout( function(){ LocationMap.updatedynamicmarkers( LocationMap.map, LocationMap.map.getBounds(), LocationMap.markerscluster ); }, 1000 );
        });
        LocationMap.map.on( 'zoomend', function(){
          clearTimeout(LocationMap.timeout);
          LocationMap.timeout = setTimeout( function(){ LocationMap.updatedynamicmarkers( LocationMap.map, LocationMap.map.getBounds(), LocationMap.markerscluster ); }, 1000 );
        });
      }
    }
  }

  async init(){
    //load leaflet
    this.loadleafletstyle().then( ()=>{
      this.loadleafletscript().then( ()=>{
        this.loadleafletclusterstyle().then( ()=>{
          this.loadleafletclusterscript().then( ()=>{
            // load main marker
            this.loadmainmarker();
            this.initdynamicmarkers();
          }).catch( (error) => {
            console.log( error );
          });
        }).catch( (error) => {
          console.log( error );
        });
      }).catch( (error) => {
        console.log( error );
      });
    }).catch( (error) => {
      console.log( error );
    });
  }

}
// const external to DomReady : ued on multiple loationmap Instances
const leafletstyle = document.createElement('link');
const leafletscript = document.createElement('script');
const leafletclusterstyle = document.createElement('link');
const leafletclusterscript = document.createElement('script');
DOMReady(function(){
  const locationmapcontainers = document.getElementsByClassName("locationview");
  if( locationmapcontainers != null ){
    for (let i = 0; i < locationmapcontainers.length; i++) {
      if( !locationmapcontainers[i].dataset.inited ){
        let locationmap = new LocationMap( locationmapcontainers[i] );
        locationmap.init();
        locationmapcontainers[i].dataset.inited = "1";
      }
    }
  }
});
